import React from 'react';

const EmptyList = () => {
  return (
    <div className="h-[45px] flex items-center justify-center border border-opacity-30 border-b-[#959595] border-t-[#959595] border-l-0 border-r-0 font-semibold">
      Нет данных
    </div>
  );
};

export default EmptyList;
